import React, { useState } from 'react';
import { Grid, Button, TextField, FormControlLabel, Checkbox } from '@mui/material';
import { TimeOffReason } from '../../../../types';
import { schedulerService } from '../../../../core/services/schedulerService';
import styles from '../SchedulerSetting.module.scss';

interface EditTimeOffReasonProps {
	reason: TimeOffReason;
	handleBackClick?: () => void;
	onTimeOffReasonUpdated?: () => void;
}

const EditTimeOffReason: React.FC<EditTimeOffReasonProps> = ({
	reason,
	handleBackClick,
	onTimeOffReasonUpdated,
}) => {
	const [reasonBuffer, setReasonBuffer] = useState({
		name: reason.name || '',
		description: reason.description || '',
		// isPaid: true, // Default value as API doesn't return this field
		// requiresApproval: reason.requiresApproval || false,
	});
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError(null);

		if (!reasonBuffer.name.trim()) {
			setError('Time off reason name is required');
			return;
		}

		try {
			setIsSubmitting(true);
			await schedulerService.updateTimeOffReason(reason.id, {
				name: reasonBuffer.name,
				description: reasonBuffer.description,
				// isPaid: reasonBuffer.isPaid,
				// requiresApproval: reasonBuffer.requiresApproval,
			});

			onTimeOffReasonUpdated?.();
			setTimeout(() => {
				handleBackClick?.();
			}, 500);
		} catch (err: any) {
			setError(err?.message || 'Failed to update time off reason');
			setIsSubmitting(false);
		}
	};

	return (
		<div className={styles.editTimeOffReason}>
			<Grid container direction="column" spacing={2} pl={2}>
				<Grid container direction="row" justifyContent="space-between">
					<Button className={styles.backButton} onClick={handleBackClick}>
						Back
					</Button>
					<Button className={styles.submitButton} onClick={handleSubmit} disabled={isSubmitting}>
						{isSubmitting ? 'Saving...' : 'Save'}
					</Button>
				</Grid>
				<Grid>
					<h1 className={styles.formTitle}>Edit Time Off Reason</h1>
				</Grid>
			</Grid>

			<form className={styles.formContainer} onSubmit={handleSubmit}>
				{error && <div style={{ color: '#d32f2f', marginBottom: 16 }}>{error}</div>}

				<TextField
					label="Time Off Reason Name"
					name="name"
					value={reasonBuffer.name}
					onChange={(e) => setReasonBuffer({ ...reasonBuffer, name: e.target.value })}
					placeholder="Enter time off reason"
					className={styles.input}
					margin="normal"
					fullWidth
					required
				/>

				<TextField
					label="Description"
					name="description"
					placeholder="Enter description (optional)"
					value={reasonBuffer.description}
					onChange={(e) => setReasonBuffer({ ...reasonBuffer, description: e.target.value })}
					className={styles.input}
					margin="normal"
					fullWidth
					multiline
					rows={3}
				/>

				{/* <FormControlLabel
					control={
						<Checkbox
							checked={reasonBuffer.isPaid}
							onChange={(e) => setReasonBuffer({ ...reasonBuffer, isPaid: e.target.checked })}
							name="isPaid"
						/>
					}
					label="Is Paid Time Off"
					className={styles.checkbox}
				/>

				<FormControlLabel
					control={
						<Checkbox
							checked={reasonBuffer.requiresApproval}
							onChange={(e) => setReasonBuffer({ ...reasonBuffer, requiresApproval: e.target.checked })}
							name="requiresApproval"
						/>
					}
					label="Requires Approval"
					className={styles.checkbox}
				/> */}
			</form>
		</div>
	);
};

export default EditTimeOffReason;
